import {ModalService} from '../../services/modal.service';
import {Component, Inject} from '@angular/core';
import {ModalComponent} from './modal.interface';
import {DialogButtonComponent} from '../buttons/dialog-button.component';

@Component({
  standalone: true,
  imports: [
    DialogButtonComponent
  ],
  template: `
    <div class="bg-theme-surface rounded-2xl shadow-xl max-w-lg w-80">
      <div class="p-6">
        <h2 class="text-xl font-bold mb-4">{{ data.title }}</h2>
        <p>{{ data.message }}</p>
        <div class="mt-4 flex justify-end gap-2">
          <app-dialog-button [text]="'Cancel'" (onClick)="close()"></app-dialog-button>
          <app-dialog-button [text]="data.confirmText!" (onClick)="confirm()" variant="primary"></app-dialog-button>
        </div>
      </div>
    </div>
  `
})
export class ExampleModalComponent implements ModalComponent {
  modalData?: any;

  constructor(
    private modalService: ModalService,
    @Inject('MODAL_DATA') public data: {
      title: string;
      message: string;
      confirmText?: string;
    }
  ) {
    // Assign the injected data to modalData to satisfy interface
    this.modalData = data;
  }

  close() {
    this.modalService.close();
  }

  confirm() {
    // @ts-ignore
    if (this.data.onConfirm) {
      // @ts-ignore
      this.data.onConfirm();
    }
    this.close();
  }
}
